// extracted by mini-css-extract-plugin
export default {"productDescription":"jda-z","featuredDescription":"kda-z","description":"lda-z","more":"mda-z","descriptionSku":"nda-z"};